import { formatDistanceToNow } from 'date-fns'
import React from 'react'
import { GeckoUnit } from 'types'

import { ResultCardProps } from './DefaultResultCard'
import {
  MetaItem,
  ResultDescription,
  ResultHeader,
  ResultItemContainer,
  ResultMeta,
  ResultTitle,
  ResultType,
} from './ResultCardStyles'

export const UnitResultCard: React.FC<ResultCardProps> = ({
  entry,
  onClick,
}) => {
  const unit = entry as GeckoUnit

  const handleClick = () => {
    onClick?.(entry)
  }

  const timeAgo = formatDistanceToNow(new Date(unit.updated_at), {
    addSuffix: true,
  })

  return (
    <ResultItemContainer onClick={handleClick}>
      <ResultHeader>
        <ResultTitle>{unit.data.name}</ResultTitle>
        <ResultType>Unit</ResultType>
      </ResultHeader>
      <ResultMeta>
        <MetaItem>Updated {timeAgo}</MetaItem>
        {unit.data.area && (
          <>
            <span>•</span>
            <MetaItem>Area: {unit.data.area}</MetaItem>
          </>
        )}
      </ResultMeta>
      {unit.data.description && (
        <ResultDescription>{unit.data.description}</ResultDescription>
      )}
    </ResultItemContainer>
  )
}
